import {
  RESET_STORE
} from "./ActionTypes";

export const resetStore = () => ({
  type: RESET_STORE
});